import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/storage';
import 'firebase/firestore';
import 'firebase/firestore';
import firebaseConfig from 'src/firebase/config';

const fC = {
  ...firebaseConfig,
};

const firebaseApp = firebase.initializeApp(fC);
const fireStore = firebase.firestore();

firebase.auth().languageCode = 'ja';

export { firebase, fireStore, firebaseApp };
